/* -------------------------------------------------------------------------- */
/*                                Button styles                               */
/* -------------------------------------------------------------------------- */

@import './bq-divider.variables';

:host {
  @apply inline-flex;
}

:host([orientation='horizontal']) {
  @apply is-full;
}

:host([orientation='vertical']) {
  @apply flex bs-full;
}

.bq-divider {
  @apply flex items-center gap-[--bq-divider--title-marginX];
}

.bq-divider--stroke {
  @apply flex-grow stroke-[color:--bq-divider--stroke-color] bs-[--bq-divider--stroke-thickness] is-full;

  &.end {
    @apply rotate-180;
  }
}

.bq-divider--title__start .bq-divider--stroke.start,
.bq-divider--title__end .bq-divider--stroke.end {
  @apply flex-grow-0 basis-[--bq-divider--stroke-basis];
}

.bq-divider--horizontal {
  @apply flex-grow;
}

.bq-divider--vertical {
  @apply bs-full flex-col items-center gap-[--bq-divider--title-marginX];

  .bq-divider--stroke {
    @apply is-[--bq-divider--stroke-thickness];
  }
}
